import { useEffect } from "react";
import { ConfirmOrgModalHeader } from "./ConfirmOrgModalHeader";
import { ConfirmOrgModalFormWrapper } from "./ConfirmOrgModalFormWrapper";

const ConfirmOrgModal = ({
  orgId,
  setOrgId,
  openConfirmOrgModal,
  setOpenConfirmOrgModal,
  fetchOrganizations,
}) => {
  useEffect(() => {
    document.body.classList.add("modal-open");
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  return (
    <>
      <div
        className="modal fade show d-block"
        id="kt_modal_add_user"
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        <div className={`modal-dialog modal-dialog-centered mw-650px`}>
          <div className="modal-content">
            <ConfirmOrgModalHeader openConfirmOrgModal={openConfirmOrgModal} setOpenConfirmOrgModal={setOpenConfirmOrgModal} setOrgId={setOrgId} />
            <div className={`modal-body scroll-y`}>
              <ConfirmOrgModalFormWrapper orgId={orgId} setOrgId={setOrgId} openConfirmOrgModal={openConfirmOrgModal} setOpenConfirmOrgModal={setOpenConfirmOrgModal} fetchOrganizations={fetchOrganizations} />
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
};

export { ConfirmOrgModal };
